import Feature from '@square/dashboard-utilities/utils/sub2/feature';
import { Status } from '@square/dashboard-data/models/squareup/sub2/subscription';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  feature: attr(Feature),
  status: attr(Status),
  subscriptionToken: attr(String)
});